// extracted by mini-css-extract-plugin
export default {"cardHeader":"c-f_cV"};